var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36958 6.45778L7.36816 6.12691C7.36816 4.75184 7.44869 3.49822 7.56998 2.681L7.67625 2.17281C7.73537 1.90366 7.81309 1.59721 7.89413 1.44076C8.19075 0.8685 8.77074 0.51444 9.3915 0.51444L9.44552 0.51444C9.85019 0.52782 10.7003 0.88291 10.7003 0.895261C12.0682 1.46922 14.7073 3.20146 15.9261 4.43641L16.2803 4.80717C16.3731 4.90766 16.4773 5.02658 16.542 5.11928C16.7581 5.40541 16.8661 5.75948 16.8661 6.11354C16.8661 6.50877 16.7448 6.87621 16.5155 7.17675L16.1516 7.56947L16.0701 7.65329C14.9641 8.85236 12.0764 10.8131 10.5658 11.4131L10.3377 11.5005C10.0632 11.5989 9.67869 11.7162 9.44552 11.727C9.1489 11.727 8.86553 11.6581 8.59542 11.5222C8.25802 11.3318 7.98892 11.0313 7.8401 10.6772C7.74531 10.4322 7.59649 9.69634 7.59649 9.68296C7.46006 8.94095 7.38095 7.7701 7.36958 6.45778ZM0.0472379 6.12033C0.047238 5.33707 0.676156 4.70203 1.45185 4.70203L4.90835 5.00771C5.51688 5.00771 6.01023 5.50587 6.01023 6.12033C6.01023 6.73582 5.51688 7.23294 4.90835 7.23294L1.45185 7.53863C0.676155 7.53863 0.0472378 6.90358 0.0472379 6.12033Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow---Left.2bc67d1a010dd55b1132de33782be1a2.svg";
export { ForwardRef as ReactComponent };